<template>
  <v-btn size="small" icon="mdi-tab-plus" title="View in tabs" color="teal" variant="tonal"
    class="pull-right"></v-btn>
</template>
